import React, { useState } from 'react';
import { Button, Form, Alert } from 'react-bootstrap';
import { useInput } from '../../hooks/useInput';
import { addDoc, collection, doc } from 'firebase/firestore';
import { db } from '../../firebase';

export default function UploadOtherProject() {
    const [msg, setMsg] = useState()
    const [title, onChangeTitle] = useInput()
    const [description, onChangeDescription] = useInput()
    const [git, onChangeGit] = useInput()
    const [link, onChangeLink] = useInput()
    const [stack, onChangeStack] = useInput()
    let data;

    const upload = async(e)=>{
        e.preventDefault();
        setMsg("")
        try {
            data = {title, description, git, link, stack}
            const root = collection(db, "WorthyProjects");
            await addDoc(root, data)
            setMsg("upload successful")
        } catch (error) {
            console.log(error)
        }
    }
  return (
    <>
        <div className='my-5'>
            <h2 className='pt-5 pb-3'>Upload A Worthy Project</h2>
            {msg && <Alert variant='success'>{msg}</Alert>}
            <Form onSubmit={upload}>
                <Form.Group>
                    <Form.Control value={title} className="mb-3" onChange={onChangeTitle} placeholder="Enter Title"></Form.Control>
                    <Form.Control value={git} className="mb-3" onChange={onChangeGit} placeholder="Enter Github Link"></Form.Control>
                    <Form.Control value={link} className="mb-3" onChange={onChangeLink} placeholder="Enter Live Link"></Form.Control>
                    <Form.Control value={stack} className="mb-3" onChange={onChangeStack} placeholder="Enter Tech Stack"></Form.Control>
                    <Form.Control value={description} className="mb-3" as="textarea" onChange={onChangeDescription} placeholder="Enter Project Description"></Form.Control>
                </Form.Group>
                <Button type='submit'>Upload</Button>
            </Form>
        </div>
    </>
  )
}
